import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ApontamentoOperacao from "model/meta/producao/ApontamentoOperacao";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import Produto from "model/administracao/cadastro/produto/Produto";
import Pessoa from "model/administracao/cadastro/Pessoa";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import Usuario from "model/administracao/cadastro/Usuario";

class ApontamentoOperacaoService implements BaseServiceCadastros<ApontamentoOperacao> {
    

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/apontamentoOperacao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ApontamentoOperacao>((resolve, reject): void => {
            api
                .get(`/apontamentoOperacao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(apontamentoOperacao: ApontamentoOperacao) {
        return new Promise<ApontamentoOperacao>((resolve, reject): void => {
            api
                .post(`/apontamentoOperacao/incluir`, JSON.stringify(apontamentoOperacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(apontamentoOperacao: ApontamentoOperacao) {
        return new Promise<ApontamentoOperacao>((resolve, reject): void => {
            api
                .put(`/apontamentoOperacao/editar`, JSON.stringify(apontamentoOperacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/apontamentoOperacao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    operacoes() {
        return new Promise<OperacaoProducao[]>((resolve, reject): void => {
            api
                .get(`/apontamentoOperacao/operacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/apontamentoOperacao/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorio(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/apontamentoOperacao/report/apontamentoMeta`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioAgrupado(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/apontamentoOperacao/report/agrupado`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ApontamentoOperacaoService;